var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDateSelected)?_c('div',{staticClass:"calendar-period"},[_vm._v("\n    "+_vm._s(_vm.period)+"\n    "),_c('icon-close',{staticClass:"reset-period-icon",nativeOn:{"click":function($event){return _vm.resetDate()}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }